<section class="destination-flight-info relative ms-large-y">
  <div class="destination-flight-info__image grey-50-bg surface-disabled-bg relative overflow-hidden">
    @if (picture(); as picture) {
      <fin-content-image class="fill" [imageData$]="picture | finToObservable" [fillParent]="true" />
    }
  </div>

  @if (showCard()) {
    <div
      class="destination-flight-info__card md-grid-auto-cols white-bg frost elevation-level-1 overflow-hidden nordic-blue-900-text text-icon-primary g-medium ps-large"
    >
      @if (isLoading()) {
        <div class="destination-flight-info__card-loader col-f flex flex--center">
          <fcom-loader [loaderType]="LoaderTheme.INLINE" />
        </div>
      } @else {
        @if (showPriceColumn()) {
          <div class="destination-flight-info__column flex flex--align-start g-small">
            <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.FLIGHT_OFFER" />
            <div class="flex flex--column">
              <span class="font-heading-4 font-title-medium ms-small-b">
                {{ 'ondMarketing.destinationFlightInfo.startingFrom' | finLocalization }}
              </span>
              <span class="font-body-1">
                {{
                  (isRoundTrip()
                    ? 'ondMarketing.destinationFlightInfo.roundTrip'
                    : 'ondMarketing.destinationFlightInfo.oneWay'
                  ) | finLocalization
                }}
              </span>
              @let price = startingFromPrice();
              @if (price) {
                <span class="font-heading-3 font-title-small">{{ price | finPrice }}</span>
              } @else {
                <span class="font-heading-3 font-title-small">
                  <fin-skeleton-loader class="destination-flight-info__price-skeleton inline-block valign-middle">
                    <div class="destination-flight-info__price-skeleton-bar"></div>
                  </fin-skeleton-loader>
                </span>
              }
            </div>
          </div>
        }

        @if (duration(); as duration) {
          <div class="destination-flight-info__column flex flex--align-start g-small">
            <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.CLOCK" />
            <div class="flex flex--column">
              <span class="font-heading-4 font-title-medium ms-small-b">
                {{ 'ondMarketing.destinationFlightInfo.flightTime' | finLocalization }}
              </span>
              <span class="font-body-1">
                {{ 'ondMarketing.destinationFlightInfo.approx' | finLocalization }}
              </span>
              <span class="font-heading-3 font-title-small">{{ duration | finDuration | async }}</span>
            </div>
          </div>
        }

        @if (airportCodes().length) {
          <div class="destination-flight-info__column flex flex--align-start g-small">
            <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.AIRPORT" />
            <div class="flex flex--column">
              <span class="font-heading-4 font-title-medium ms-small-b">
                {{ 'ondMarketing.destinationFlightInfo.airports' | finLocalization }}
              </span>
              @if (cityName(); as cityName) {
                <span class="font-body-1">{{ cityName }}</span>
              }
              <span class="font-heading-3 font-title-small">{{ airportCodes().join(', ') }}</span>
            </div>
          </div>
        }

        @if (isDirect()) {
          <div class="destination-flight-info__column flex flex--align-start g-small">
            <fcom-icon class="icon-large flex--shrink0" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
            <div class="flex flex--column">
              <span class="font-heading-4 font-title-medium ms-small-b">
                {{ 'ondMarketing.destinationFlightInfo.directFlights' | finLocalization }}
              </span>
              @let frequency = directFrequency();
              @if (frequency) {
                <span class="font-body-1 font-body-medium" aria-hidden="true">
                  {{ frequency.count }}
                  <fcom-icon class="ms-xxsmall-x" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL" />
                  {{ directFrequencyUnitKey() | finLocalization }}
                </span>
                <span class="is-vishidden">
                  {{ directFrequencyKey() | finLocalization: { count: frequency.count } }}
                </span>
              }
            </div>
          </div>
        }
      }
    </div>
  }
</section>
